import { render, staticRenderFns } from "./import-process-progress.vue?vue&type=template&id=88ecbf74&"
import script from "./import-process-progress.vue?vue&type=script&lang=js&"
export * from "./import-process-progress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports